export default __webpack_public_path__ + "static/media/setting_active.28c37279.svg";